(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('TicketrealtimeDetailController', TicketrealtimeDetailController);

    TicketrealtimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ticketrealtime'];

    function TicketrealtimeDetailController($scope, $rootScope, $stateParams, previousState, entity, Ticketrealtime) {
        var vm = this;

        vm.ticketrealtime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:ticketrealtimeUpdate', function(event, result) {
            vm.ticketrealtime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
